import {
  CheckArgumentsTemplateListView,
  type CheckArgumentsTemplateListConfig,
} from "../check-arguments-templates-shared";

const config: CheckArgumentsTemplateListConfig = {
  listApiPath:
    "/api/internal/client-portal/check-arguments-templates/credit-report/",
  settingsPathPrefix: "credit-report-templates",
  pageTitle: (t) => t("Credit report"),
  testIdPrefix: "credit-report-template",
  apiPathPrefix: "credit-report",
  filterBarTestId: "credit-report",
};

export const CreditReportTemplateListView =
  CheckArgumentsTemplateListView(config);
